//export { RecentlyViewedLinks as default } from "snew-classic-ui";
export default () => null;



// WEBPACK FOOTER //
// ./src/components/snew/RecentlyViewedLinks.js